module.exports = __webpack_public_path__ + "static/img/bier_3.c38629a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bier/bier_3.jpg
// module id = 172
// module chunks = 1